import { cn } from "@/utils/ui";

// Negative delays so every bar is already mid-wave on mount.
const BAR_DELAYS_MS = [-720, -540, -360, -180, 0];

type WaveSpinnerProps = {
  size?: number;
  className?: string;
};

export const WaveSpinner = ({ size = 20, className }: WaveSpinnerProps) => (
  <div
    aria-hidden="true"
    data-wave-spinner
    className={cn("flex items-center justify-between", className)}
    style={{ width: size, height: size }}
  >
    {BAR_DELAYS_MS.map((delay) => (
      <span
        key={delay}
        className="h-full w-[12%] scale-y-[0.3] animate-wave-bar rounded-full bg-current motion-reduce:animate-none"
        style={{ animationDelay: `${delay}ms` }}
      />
    ))}
  </div>
);
